//====================================================
//  Initialization Counter
//====================================================
function fn_parts_placeholder(){
	if ($('.js-placeholder-trigger').length){
	    $('.js-placeholder-trigger').focusin(function() {
	        $(this).closest('.placeholder').addClass('active');
		})

		$('.js-placeholder-trigger').blur(function() {
			if (!$(this).val().length){
	        	$(this).closest('.placeholder').removeClass('active');
			}
		});
	}
}

